<template>
    <div class="chonghuan-station flex justify-content-between">
        <!-- <MyMap /> -->
        <!-- <div class="cover cover-home"></div> -->
        <MyHeader />
        <div class="page-left flex">
            <div class="left-part">
                <Station1 />
                <Station2 />
                <Station3 />
            </div>
            <div class="left-part">
                <Station4 />
                <Station5 />
                <Station6 />
            </div>
        </div>
        <div class="page-center flex1">
            <StationC1 v-if="type == 1" />
            <StationC2 v-else :info="infoData" />
            <!-- <Station7 class="center-bottom" /> -->
            <MyFooter />
        </div>
        <div class="page-right">
            <Station8 v-if="type == 1" />
            <Station9 v-else @getInfo="getInfo" />
        </div>
    </div>
</template>

<script>
import MyHeader from '@/views/components/MyHeader.vue'
import Station1 from './chonghuan/station-1.vue'
import Station2 from './chonghuan/station-2.vue'
import Station3 from './chonghuan/station-3.vue'
import Station4 from './chonghuan/station-4.vue'
import Station5 from './chonghuan/station-5.vue'
import Station6 from './chonghuan/station-6.vue'
// import Station7 from './chonghuan/station-7.vue'
import Station8 from './chonghuan/station-8.vue'
import Station9 from './chonghuan/station-9.vue'
import StationC1 from './chonghuan/station-c1.vue'
import StationC2 from './chonghuan/station-c2.vue'
import MyFooter from './components/myFooter'
export default {
    components: {
        MyHeader,
        Station1,
        Station2,
        Station3,
        Station4,
        Station5,
        Station6,
        // Station7,
        Station8,
        Station9,
        StationC1,
        StationC2,
        MyFooter
    },
    data() {
        let { type, interval, stationId } = this.$route.query || {}
        // 581abc7ea6ce47668a3f03eba90523de 石河子北八路站换电站
        // 90d531b781b6479f9ef3f207ed9808d4 鄂钢1号门充电站
        return {
            type: type || 1,
            interval,
            stationId,
            intervalNum: 15,
            pageInterval: null,
            infoData: {}
        }
    },
    mounted() {
 
        if(this.pageInterval) {
            clearInterval(this.pageInterval)
            this.pageInterval = null
        }
        // this.pageInterval = setInterval(() => {
        //     this.intervalNum--
        //     if(this.intervalNum < 0 ) {
        //         if(this.stationId == '581abc7ea6ce47668a3f03eba90523de') {
        //             this.$router.replace({
        //                 path: 'chonghuan-station',
        //                 query: {
        //                     stationId: '90d531b781b6479f9ef3f207ed9808d4',
        //                     type: 2
        //                 }
        //             })
        //         } else {
        //              this.$router.replace({
        //                 path: '/batteryCompartment',
        //                 query: {
        //                     stationId: 'd13e09fd3c89459789d3933008d4bcfa',
        //                     batteryId: '08IPBN80032A3AC180200005',
        //                     chargingWarehouseNumber: this.chargingWarehouseNumber || ''
        //                 }
        //             })
        //         }
        //     }
        // }, 1000)
        document.onmousemove = ((event) => {
            console.log(event)
            this.intervalNum = this.intervalNumSet
        })
        // if(this.interval) {
        // }
    },
    methods: {
        getInfo(data) {
            console.log('this.infoData', data)
            this.infoData = data
        }
    },
    destroyed() {
        clearInterval(this.pageInterval)
    }
}
</script>

<style lang="scss" scoped>
@import './chonghuan/chonghuan.scss';
.chonghuan-station {
    position: relative;
    height: 100%;
    background: url(~@/assets/images/chonghuan/station-bg.png) no-repeat;
    background-size: 100% 100%;
    
    .page-left, .page-right {
        // width: $PageWidth1;
        height: calc(100% - $HeaderHeight);
        // position: absolute;
        margin-top: $HeaderHeight;
        position: relative;
        flex-shrink: 0;
    }
    .page-left {
        padding-left: $PageRange;
        .left-part {
            width: 585px;
            &:first-child {
                margin-right: 30px;
            }
        }
    }
    .page-center {
        position: relative;
        .center-bottom {
            position: absolute;
            bottom: 50px;
            left: 50px;
            width: calc(100% - 50px);
        }
    }
    .page-right {
        padding-right: $PageRange;
        width: 655px;
    }
}
</style>